export default __webpack_public_path__ + "static/social-media-default-image-f73979dbee1e7f63618a2ef97b037d04.jpg";